import _ from 'lodash';
import { MyWeeklySchedule } from '../../../devices/residential-devices/thermostat/types';

// Whether all the weekdays have the same schedule
export function weekdaysEqual(schedule: MyWeeklySchedule): boolean {
  return (
    _.isEqual(schedule['1'], schedule['2']) &&
    _.isEqual(schedule['1'], schedule['3']) &&
    _.isEqual(schedule['1'], schedule['4']) &&
    _.isEqual(schedule['1'], schedule['5'])
  );
}

// Whether both weekend days have the same schedule
export function weekendsEqual(schedule: MyWeeklySchedule): boolean {
  return _.isEqual(schedule['0'], schedule['6']);
}

// Where all days have the same schedule
export function allDaysEqual(schedule: MyWeeklySchedule): boolean {
  return (
    weekdaysEqual(schedule) &&
    weekendsEqual(schedule) &&
    _.isEqual(schedule['0'], schedule['1'])
  );
}
